"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationManagerSymbol = void 0;
exports.NavigationManagerSymbol = Symbol('NavigationManager');
//# sourceMappingURL=navigationManager.js.map